class InteractiveDevice {
  constructor() {
    this.currentActive = 1;
    this.init();
  }

  init() {
    // Get all interactive elements
    this.leftNumbers = document.querySelectorAll('.interactive-device .number-circle');
    this.rightLabels = document.querySelectorAll('.interactive-device .device-label');
    this.descriptionText = document.querySelector('.interactive-device .description');

    if (!this.descriptionText || this.leftNumbers.length === 0) return;

    // Set initial state
    this.updateDescription(1);
    this.setActiveState(1);

    // Add event listeners to left number row
    this.leftNumbers.forEach((number) => {
      const num = parseInt(number.dataset.feature);

      number.addEventListener('click', () => {
        this.handleNumberClick(num);
      });

      number.addEventListener('mouseenter', () => {
        this.handleHover(num, 'enter');
      });

      number.addEventListener('mouseleave', () => {
        this.handleHover(num, 'leave');
      });
    });

    // Add event listeners to right device labels
    this.rightLabels.forEach((label) => {
      const num = parseInt(label.dataset.feature);

      label.addEventListener('click', () => {
        this.handleNumberClick(num);
      });

      label.addEventListener('mouseenter', () => {
        this.handleHover(num, 'enter');
      });

      label.addEventListener('mouseleave', () => {
        this.handleHover(num, 'leave');
      });
    });
  }

  handleNumberClick(num) {
    this.currentActive = num;
    this.updateDescription(num);
    this.setActiveState(num);
  }

  handleHover(num, action) {
    // Sync hover effects between left and right sides
    if (action === 'enter') {
      this.setHoverState(num, true);
    } else {
      this.setHoverState(num, false);
    }
  }

  setHoverState(num, isHovering) {
    // Add/remove hover class to both left and right elements
    const leftNumber = document.querySelector(`.interactive-device .number-circle[data-feature="${num}"]`);
    const rightLabel = document.querySelector(`.interactive-device .device-label[data-feature="${num}"]`);

    if (leftNumber) {
      leftNumber.classList.toggle('hover', isHovering);
    }

    if (rightLabel) {
      rightLabel.classList.toggle('hover', isHovering);
    }
  }

  updateDescription(num) {
    if (this.descriptionText && window.deviceFeatures && window.deviceFeatures[num]) {
      this.descriptionText.innerHTML = window.deviceFeatures[num];
    }
  }

  setActiveState(num) {
    // Remove active class from all elements
    this.leftNumbers.forEach((number) => {
      const numberValue = parseInt(number.dataset.feature);
      if (numberValue === num) {
        number.classList.add('active');
      } else {
        number.classList.remove('active');
      }
    });

    this.rightLabels.forEach((label) => {
      const labelValue = parseInt(label.dataset.feature);
      if (labelValue === num) {
        label.classList.add('active');
      } else {
        label.classList.remove('active');
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new InteractiveDevice();
});
